window.customElements.define('fostr-mobilemenu', class FostrMobileMenu extends HTMLElement {
  constructor() {
    super();

    this.isVisible = false;
    this.transitionTime = 300;
    this.animationStyle = null;
    this.mobilemenuEl = null;
    this.pageWrapEl = null;
    this.isHiddenClass = 'mobilemenu--hidden';
    this.isVisibleClass = 'mobilemenu--isVisible';
    this.isActiveClass = 'active';
    this.dropdownListTarget = '.mobilemenu__link[aria-expanded]';
    this.dropdownExpandedListTarget = '.mobilemenu__link[aria-expanded="true"]';
    this.tierActiveTarget = 'fostr-mobilemenu-tier.' + this.isActiveClass;
    this.linkTarget = '.mobilemenu__link';
    this.mobilemenuToggleTarget = '[data-mobilemenu="toggle"]';
    this.mobilemenuCloseTarget = 'fostr-mobilemenu-button-close,fostr-mobilemenu-curtain';
  }

  connectedCallback() {
    this.mobilemenuAddCurtain();
    this.mobilemenuEl = this.querySelector('fostr-mobilemenu aside');
    this.pageWrapEl = document.querySelector('.fostr-mobilemenu-page');
    this.setMobilemenuAnimationStyle();
    this.setMobilemenu();

    let toggleButtons = document.querySelectorAll(this.mobilemenuToggleTarget);
    for (var i=0; i<toggleButtons.length; i++) {
      toggleButtons[i].addEventListener('click', this.toggleButtonEventClick.bind(this));
    }

    // Event Listeners
    this.addEventListener('click', this.mobilemenuCloseEventClick.bind(this));
    this.addEventListener('click', this.dropdownListEventClick.bind(this));
    this.addEventListener('click', this.backButtonEventClick.bind(this));
    this.addEventListener('click', this.tierLinkEventClick.bind(this));
  }

  disconnectedCallback() {

    // Remove classes
    this.pageWrapEl.classList.remove('active');
    this.pageWrapEl.classList.remove('mobilemenu--push-left');
    this.pageWrapEl.classList.remove('mobilemenu--push-right');
    this.pageWrapEl.classList.remove('mobilemenu--overlay-left');
    this.pageWrapEl.classList.remove('mobilemenu--overlay-right');
    this.pageWrapEl.classList.remove('mobilemenu--overlay-bottom');

    // Remove eventListeners
    let toggleButtons = document.querySelectorAll(this.mobilemenuToggleTarget);
    for (var i = 0; i < toggleButtons.length; i++) {
      toggleButtons[i].removeEventListener('click', this.toggleButtonEventClick.bind(this));
    }

    this.removeEventListener('click', this.mobilemenuCloseEventClick.bind(this));
    this.removeEventListener('click', this.dropdownListEventClick.bind(this));
    this.removeEventListener('click', this.backButtonEventClick.bind(this));
    this.removeEventListener('click', this.tierLinkEventClick.bind(this));

    // Reset properties
    this.animationStyle = null;
  }

  // Methods
  mobilemenuHide() {
    this.mobilemenuEl.setAttribute('aria-expanded', 'false');
    this.classList.remove(this.isVisibleClass);
    this.pageWrapEl.classList.remove(this.isActiveClass);
    this.isVisible = false;
    this.setFirstTier();

    document.querySelector('.mobilemenu-button').classList.remove('open');
    document.body.classList.remove('overflow-hidden');
  }

  mobilemenuShow() {
    this.mobilemenuEl.setAttribute('aria-expanded', 'true');
    this.classList.add(this.isVisibleClass);
    this.pageWrapEl.classList.add(this.isActiveClass);
    this.isVisible = true;

    document.querySelector('.mobilemenu-button').classList.add('open');
    document.body.classList.add('overflow-hidden');
  }

  toggleButtonEventClick() {
    this.mobilemenuToggle();
    this.setFirstTier();
  }

  mobilemenuAddCurtain() {
    if (document.querySelector('fostr-mobilemenu-curtain')) {
      return;
    }
    this.innerHTML = '<fostr-mobilemenu-curtain></fostr-mobilemenu-curtain>' + this.innerHTML;
  }

  dropdownListEventClick(event) {
    if (!event.target.closest(this.dropdownListTarget)) return false;

    let dropdownListEl = event.target;
    if (dropdownListEl.getAttribute('aria-expanded') == 'false') {
      dropdownListEl.setAttribute('aria-expanded', 'true');
      return true;
    }

    dropdownListEl.setAttribute('aria-expanded', 'false');
    return true;
  }

  dropdownListCollapseAll() {
    // close all expanded dropdown lists
    let expandedDropdownListEls = this.mobilemenuEl.querySelectorAll(this.dropdownExpandedListTarget);

    setTimeout(() => {
      for (var i = 0; i < expandedDropdownListEls.length; i++) {
        expandedDropdownListEls[i].setAttribute('aria-expanded', 'false');
      }
    }, this.transitionTime);
  }

  nextTier(tierEl) {
    if (!tierEl) {
      return;
    }

    tierEl.classList.add(this.isActiveClass);

    this.attachScrollingEventListener();
    this.setBackButton();
    this.dropdownListCollapseAll();
  }

  previousTier() {
    var activeTiers = this.mobilemenuEl.querySelectorAll(this.tierActiveTarget);
    var lastActiveTier = activeTiers[(activeTiers.length - 1)];

    lastActiveTier.classList.remove(this.isActiveClass);

    this.setBackButton();
    this.dropdownListCollapseAll();
  }

  setBackButton() {
    if (!this.mobilemenuEl) {
      return;
    }

    let backButton = this.mobilemenuEl.querySelector('fostr-mobilemenu-button-back');
    if (!backButton) {
      return false;
    }

    if (this.mobilemenuEl.querySelectorAll(this.tierActiveTarget).length == 1) {
      backButton.classList.add(this.isHiddenClass);
    } else {
      backButton.classList.remove(this.isHiddenClass);
    }
    return true;
  }

  backButtonEventClick(event) {
    if (!event.target.closest('fostr-mobilemenu [data-mobilemenu="back"]')) {
      return false;
    }

    this.previousTier();

    return true;
  }

  unsetAllActiveTiers() {
    let activeTierEls = this.mobilemenuEl.querySelectorAll(this.tierActiveTarget);
    let self = this;
    setTimeout(() => {
      for (var i = 0; i < activeTierEls.length; i++) {
        let activeTierEl = activeTierEls[i];
        activeTierEl.classList.remove(self.isActiveClass);
      }
    }, this.transitionTime);
  }

  setFirstTier() {
    let tier1El = this.mobilemenuEl.querySelector('#tier-1-0-0');

    if (!tier1El) {
      return;
    }

    if (tier1El.classList.contains(this.isActiveClass)) {
      this.unsetAllActiveTiers();
      this.dropdownListCollapseAll();
    } else {
      tier1El.classList.add(this.isActiveClass);
      this.attachScrollingEventListener();
    }

    this.setBackButton();
  }

  mobilemenuToggle() {
    if (!this.mobilemenuEl) {
      return;
    }

    if (!this.isVisible) {
      this.mobilemenuShow();
    } else {
      this.mobilemenuHide();
    }
  }

  setMobilemenuAnimationStyle() {
    if (!this.mobilemenuEl) {
      return false;
    }

    this.animationStyle = (this.mobilemenuEl.classList.contains('mobilemenu--push-left')) ? 'push-left' : this.animationStyle;
    this.animationStyle = (this.mobilemenuEl.classList.contains('mobilemenu--push-right')) ? 'push-right' : this.animationStyle;
    this.animationStyle = (this.mobilemenuEl.classList.contains('mobilemenu--overlay-left')) ? 'overlay-left' : this.animationStyle;
    this.animationStyle = (this.mobilemenuEl.classList.contains('mobilemenu--overlay-right')) ? 'overlay-right' : this.animationStyle;
    this.animationStyle = (this.mobilemenuEl.classList.contains('mobilemenu--overlay-bottom')) ? 'overlay-bottom' : this.animationStyle;
  }

  isAnimationStylePush() {
    return (this.animationStyle === 'push-left' || this.animationStyle === 'push-right');
  }

  setMobilemenu() {
    if (!this.mobilemenuEl) {
      return false;
    }

    if (!this.pageWrapEl) {
      console.log('Fostr MobileMenu: Please add the page wrap.');
      return;
    }

    this.pageWrapEl.classList.add('mobilemenu--' + this.animationStyle);
    this.classList.add('mobilemenu--' + this.animationStyle);

    return true;
  }

  // Event handlers
  tierLinkEventClick(event) {
    if (!event.target.closest(this.linkTarget)) {
      return false;
    }

    if (event.target.tagName === 'A') {
      return;
    }

    let linkEl = event.target;
    if (linkEl.nextElementSibling) {
      return true;
    }

    let nextTierEl = this.mobilemenuEl.querySelector('#' + linkEl.id.replace('-link', ''));
    if (!nextTierEl) {
      return true;
    }

    this.nextTier(nextTierEl);

    return true;
  }

  mobilemenuCloseEventClick(event) {
    if (!event.target.closest(this.mobilemenuCloseTarget)) return false;

    this.mobilemenuHide();
  }

  attachScrollingEventListener() {
    if (!this.mobilemenuEl) {
      return;
    }

    let lastActiveTierEl = this.mobilemenuEl.querySelectorAll('.' + this.isActiveClass + ':not(.mobilemenu--watchingScroll)')[this.mobilemenuEl.querySelectorAll('.' + this.isActiveClass + ':not(.mobilemenu--watchingScroll)').length - 1];
    if (!lastActiveTierEl) {
      return;
    }

    let lastActiveTierBodyEl = lastActiveTierEl.querySelector('fostr-mobilemenu-tier-body');
    if (!lastActiveTierBodyEl) {
      return;
    }

    lastActiveTierBodyEl.addEventListener('scroll', () => {
      if (!lastActiveTierBodyEl) {
        return;
      }

      if (lastActiveTierBodyEl.scrollTop > 0) {
        lastActiveTierEl.classList.add('mobilemenu--scrolling');
      } else {
        lastActiveTierEl.classList.remove('mobilemenu--scrolling');
      }
    }, {
      passive: true
    });

    lastActiveTierEl.classList.add('mobilemenu--watchingScroll');
  }
});
